import I18N from '@leverege/i18n';
import GroupingsViewer from "./GroupingsViewer.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.groupings.dataViewers.GroupingsDataViewer');
export default {
  type: 'molten.Groupings',
  name: tf('name'),
  icon: tfIcon('icon', 'fa fa-star fa-fw'),
  location: 'aux',
  matches: {
    type: 'GroupDataViewer'
  },
  component: GroupingsViewer
};